<div (click)="hideMe.emit()" class="header">
  @if (chatAvatar) {
    <div class="avatar-container">
      <div class="status {{ onlineStatus }}"></div>
      <img [src]="chatAvatar" />
    </div>
  }
  @if (chatTitle) {
    <h3>
      {{ chatTitle }}
      @if (!chatAvatar) {
        <span class="status {{ onlineStatus }}"></span>
      }
    </h3>
  }
  <button (click)="closeMe.emit()" mat-icon-button>
    <mat-icon>close</mat-icon>
  </button>
</div>
<div class="body">
  <div
    [title]="$safeNavigationMigration((messages$ | async)?.length)"
    class="messages"
  >
    <lib-scrollbar
      (scrolledOffset)="currentScroll($event)"
      [percent]="restartScroll | async"
    >
      <div class="message-list">
        @let allMessages = messages$ | async;
        @for (
          message of allMessages;
          track trackMessage(i, message);
          let i = $index
        ) {
          <div
            [ngClass]="{
              mine: message.authorId | isMe,
              theirs: !(message.authorId | isMe),
              followedBySameAuthor:
                allMessages[i + 1]?.authorId === message.authorId,
              precededBySameAuthor:
                allMessages[i - 1]?.authorId === message.authorId,
            }"
            class="message"
          >
            @switch (message.type) {
              @case ('Text') {
                <div
                  [innerHTML]="message.comment | parseMessage"
                  [matTooltip]="
                    message.date * 1000
                      | dateTimeFromMilliseconds
                      | dateTimeToJsDate
                      | date: 'medium'
                  "
                  [title]="
                    message.date * 1000
                      | dateTimeFromMilliseconds
                      | dateTimeToJsDate
                      | date: 'medium'
                  "
                  class="container"
                ></div>
              }
              @case ('Attachments') {
                <lib-chat-attachments
                  [attachments]="message.comment"
                  [conversationId]="conversationId$ | async"
                  [date]="message.date"
                  [messageId]="message.standaloneSupportMessageId"
                  [ngClass]="{
                    mine: message.authorId | isMe,
                    theirs: !(message.authorId | isMe),
                  }"
                ></lib-chat-attachments>
              }
            }
          </div>
        }
      </div>
    </lib-scrollbar>
  </div>
  <div class="info">Wakacyjne godziny pracy - 9:00 - 17:00 pn-pt</div>
  <div class="form-container">
    <div
      (click)="inputNode.focus()"
      (keydown.enter)="sendMessage($event)"
      [ngClass]="{ dragOver: dragOver$ | async }"
      class="input"
    >
      <div
        #inputNode
        (dragleave)="dragOver$.next(false)"
        (dragover)="dragOver$.next(true)"
        (drop)="dropped($event); dragOver$.next(false)"
        (input)="inputEvent($event)"
        (paste)="onPaste($event)"
        autofocus
        contenteditable="true"
      ></div>
    </div>
    <div class="options">
      <lib-button class="attach" icon-only>
        <input
          #FileInput
          (change)="inputFileChanged(FileInput)"
          multiple
          type="file"
        />
        <mat-icon>attachment</mat-icon>
      </lib-button>
    </div>
  </div>
  @if (uploadInProgress$ | async) {
    <mat-progress-bar [value]="uploadProgress$ | async"></mat-progress-bar>
  }
  @if ((filesToBeUploaded$ | async)?.length) {
    <div class="filesToBeUploaded">
      @for (file of filesToBeUploaded$ | async; track file) {
        <div [matTooltip]="file.name" class="file">
          @if (file.uploadInProgress && !file.uploadCompleted) {
            <mat-progress-spinner
              [diameter]="40"
              mode="indeterminate"
            ></mat-progress-spinner>
          }
          @switch (file.type) {
            @case ('image/jpeg') {
              <img [src]="file.url" />
            }
            @case ('image/png') {
              <img [src]="file.url" />
            }
            @default {
              <h1>{{ file.extension }}</h1>
            }
          }
          @if (!(uploadInProgress$ | async)) {
            <lib-button (click)="deleteFileToBeUploaded(file.file)" icon-only>
              <mat-icon>cancel</mat-icon>
            </lib-button>
          }
        </div>
      }
    </div>
  }
</div>
